module.exports = __webpack_public_path__ + "media/1x1/tk-7aaccddb.svg";